import { useCallback } from 'react';

import _ from 'lodash';

import { fileSize } from 'src/app_deprecated/constants/AppConstants';

import { useUploadDiscountMenuImage } from 'src/app/queries/discounts/discount';
import { useNotificationActions } from 'src/app/state/notifications';

type UseMenuCardImageUploadProps = {
  onUploadSuccess: (imageUrl: string) => void;
};

export function useMenuCardImageUpload({ onUploadSuccess }: UseMenuCardImageUploadProps) {
  const notifications = useNotificationActions();
  const uploadMenuImage = useUploadDiscountMenuImage();

  return useCallback(
    (image: HTMLInputElement) => {
      const imageFile = (image.files && image.files.length > 0 && image.files[0]) || null;
      if (imageFile === null) {
        notifications.error({ message: 'Selecting image failed, please try again.' });
        return;
      }
      const sizeReader = new FileReader();

      let accurateFileSize = 0;
      sizeReader.onload = () => {
        const arrayBuffer = sizeReader.result as ArrayBuffer;
        const uInt8Array = new Uint8Array(arrayBuffer);
        accurateFileSize = uInt8Array.length;
      };

      sizeReader.readAsArrayBuffer(imageFile);

      if (accurateFileSize > fileSize.FOUR_MB) {
        notifications.error({ message: 'Image size must be less than 4 MB' });
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(imageFile);
      reader.onload = (upload) => {
        if (
          upload.target &&
          typeof upload.target.result === 'string' &&
          _.includes(upload.target.result.split(',')[0], 'base64')
        ) {
          const [, base64String] = upload.target.result.split(',');
          const byteString = base64String;
          uploadMenuImage.mutate(
            {
              Base64Image: byteString,
            },
            {
              onSuccess: (data) => {
                notifications.success({
                  message: 'Image uploaded successfully',
                });
                onUploadSuccess(data.MenuDisplayImageUrl);
              },
              onError: () => {
                notifications.apiError({
                  message: 'Uploading image failed',
                });
              },
            }
          );
        }
      };
    },
    [notifications, onUploadSuccess, uploadMenuImage]
  );
}
